const ACTIONS = {
  FETCH_LOG_DOWNLOAD_INIT: "FETCH_LOG_DOWNLOAD_INIT",
  FETCH_LOG_DOWNLOAD_SUCCESS: "FETCH_LOG_DOWNLOAD_SUCCESS",
  FETCH_LOG_DOWNLOAD_FAILURE: "FETCH_LOG_DOWNLOAD_FAILURE",
};

export default ACTIONS;
